import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';


export default function ScrollTop() {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0,0);
  }, [location]);  
}
